import { logError } from './logUtils'

let initialized = false

export const initIntercom = ({
  appId,
  apiBase = 'https://api-iam.intercom.io',
  name,
  email,
  createdAt,
  properties = {}
}) => {
  if (initialized) {
    return
  }

  window.Intercom('boot', {
    api_base: apiBase,
    app_id: appId,
    name,
    email,
    created_at: createdAt,
    ...properties
  })

  initialized = true
}

export const showIntercomHelpWidget = () => {
  if (initialized) {
    window.Intercom('update', {
      hide_default_launcher: false
    })
  } else {
    logError('Tried to init intercom chat launcher before it was initialized')
  }
}

export const hideIntercomHelpWidget = () => {
  if (initialized) {
    window.Intercom('update', {
      hide_default_launcher: true
    })
  } else {
    logError('Tried to hide intercom chat launcher before it was initialized')
  }
}

export const openIntercomHelpPopup = () => {
  if (initialized) {
    window.Intercom('show')
  } else {
    logError('Tried to show intercom chat before it was initialized')
  }
}

export const isInitialized = () => initialized
